var calendar = "https://shopfront-cdn.tekoapis.com/static/3c2b47d8956c44b3.svg";

export { calendar as default };
